import type { MetricsRange } from "./types";

/** `routine`: include health checks, audits, inventories and facts that didn't fail (left out by default). */
export type OpFilter = { serverId?: string; siteId?: string; limit?: number; routine?: boolean };

export const keys = {
  authState: ["auth", "state"] as const,
  me: ["me"] as const,
  linodeMeta: ["meta", "linode"] as const,
  org: (orgId: string) => ["org", orgId] as const,
  servers: (orgId: string) => ["org", orgId, "servers"] as const,
  server: (orgId: string, id: string) => ["org", orgId, "server", id] as const,
  metrics: (orgId: string, id: string, range: MetricsRange) => ["org", orgId, "server", id, "metrics", range] as const,
  sites: (orgId: string) => ["org", orgId, "sites"] as const,
  site: (orgId: string, id: string) => ["org", orgId, "site", id] as const,
  operationLists: (orgId: string) => ["org", orgId, "operations"] as const,
  operations: (orgId: string, f: OpFilter) => ["org", orgId, "operations", f] as const,
  operation: (orgId: string, id: string) => ["org", orgId, "operation", id] as const,
  activity: (orgId: string, limit: number) => ["org", orgId, "activity", limit] as const,
  // Under the site key, so refreshing a site refreshes its repo and deploys too.
  repo: (orgId: string, siteId: string) => ["org", orgId, "site", siteId, "repo"] as const,
  deployments: (orgId: string, siteId: string, envId: string) => ["org", orgId, "site", siteId, "deployments", envId] as const,
  passkeys: ["me", "passkeys"] as const,
  /** The person's own work in every org (api/work.ts). */
  myWork: ["me", "work"] as const,
  orgInfo: (orgId: string) => ["org", orgId, "info"] as const,
  members: (orgId: string) => ["org", orgId, "members"] as const,
};
